import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainPage from './pages/MainPage';
import ServiceSelectPage from './pages/ServiceSelectPage';
import AIAnalysisPage from './pages/AIAnalysisPage';
import PricingPage from './pages/PricingPage';
import BookingPage from './pages/BookingPage';
import TrackingPage from './pages/TrackingPage';
import ManagerRegisterPage from './pages/ManagerRegisterPage';
import TruckRegisterPage from './pages/TruckRegisterPage';
import TruckMatchPage from './pages/TruckMatchPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import BottomNav from './components/BottomNav';
import './App.css';

function App() {
  const [user, setUser] = useState(null);

  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/login" element={<LoginPage setUser={setUser} />} />
          <Route path="/" element={<MainPage user={user} />} />
          <Route path="/service-select" element={<ServiceSelectPage />} />
          <Route path="/ai-analysis" element={<AIAnalysisPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/tracking" element={<TrackingPage />} />
          <Route path="/manager-register" element={<ManagerRegisterPage />} />
          <Route path="/truck-register" element={<TruckRegisterPage />} />
          <Route path="/truck-match" element={<TruckMatchPage />} />
          <Route path="/profile" element={<ProfilePage user={user} setUser={setUser} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <BottomNav />
      </div>
    </Router>
  );
}

export default App;
